/**
 * Auto-saves the "who should this letter be addressed to?" field on the
 * cart page (sections/cart.liquid) to Shopify's cart note (cart.note) via
 * /cart/update.js - deliberately not a line-item property, since the
 * customer can come back and edit it after the item's already in the
 * cart, independent of quantity/checkout. Saves shortly after the
 * customer stops typing, and immediately on blur so it's not lost if they
 * click straight to checkout.
 *
 * Also present as name="note" on the surrounding {% form 'cart' %} (see
 * cart.liquid), so the note is still correctly submitted even if this
 * script fails to load or a request is in flight when the customer
 * submits - this is a progressive enhancement on top of that, not the
 * only way the note reaches Shopify.
 */
(function () {
  var input = document.querySelector('[data-cart-note]');
  if (!input) return;

  var status = document.querySelector('[data-cart-note-status]');
  var debounceTimer = null;
  var lastSavedValue = input.value;
  var DEBOUNCE_MS = 600;

  function setStatus(text) {
    if (status) status.textContent = text;
  }

  function save() {
    var value = input.value;
    if (value === lastSavedValue) return;

    setStatus('Saving…');

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ note: value }),
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Request failed');
        lastSavedValue = value;
        setStatus('Saved');
      })
      .catch(function () {
        setStatus("Couldn't save - it'll still be included if you submit the form below.");
      });
  }

  input.addEventListener('input', function () {
    setStatus('');
    if (debounceTimer) clearTimeout(debounceTimer);
    debounceTimer = setTimeout(save, DEBOUNCE_MS);
  });

  input.addEventListener('blur', function () {
    if (debounceTimer) clearTimeout(debounceTimer);
    save();
  });
})();
